import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProgressLoad from "../Tools/ProgressLoad";
import { db } from "../auth/UsersConfig/Authfirebase";
import { getDoc, doc } from "firebase/firestore";
import ShareButton from "../Tools/ShareButton";
import WhatsAppButton from "../Tools/WhatsAppButton";
import LocationButton from "../Tools/LocationButton";
import './DetalleProducto.css';
import MenuThumbnails from "./MenuThumbnails";
import { ConvertObjToArray } from "../Tools/Converts";
import { Typography } from "@mui/material";
import { Button, Form } from 'react-bootstrap';
import { FaShoppingCart } from 'react-icons/fa'; // Importa el icono de carrito

import { useCart } from "../auth/UsersConfig/CartContext";

const DetalleProducto = () => {
    const { IdDoc } = useParams();
    const [ProgrLoading, setProgrLoading] = useState(false);
    const url = "https://shopsquares.web.app//DetalleProducto/" + IdDoc;
    const phoneNumber = '526621679580';
    const Location = { Lat: '29.1073297', Lon: '-111.0130419' };
    const [item, setItem] = useState(null);
    const [selectImg, setSelectImg] = useState(null);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [confirmationMessage, setConfirmationMessage] = useState(null);
    const { addToCart } = useCart();

    const GetProductos = async () => {
        setProgrLoading(true);
        try {
            const myDoc = doc(db, "products", IdDoc);
            const snapshot = await getDoc(myDoc);
            if (snapshot.exists()) {
                const data = snapshot.data();
                setItem(data);
                setSelectImg(data.Img[1].Url);
            } else {
                console.log("No such document!");
            }
            HideLoading();
        } catch (error) {
            console.error("Error fetching document:", error);
        }
    }

    useEffect(() => {
        GetProductos();
    }, [IdDoc]);

    const HideLoading = () => {
        setTimeout(() => { setProgrLoading(false); }, 3000);
    }

    const Select = (s) => {
        if (selectImg !== s.Url) {
            setSelectImg(s.Url);
        }
    }

    const openFullScreen = () => {
        setIsFullScreen(true);
    }

    const closeFullScreen = () => {
        setIsFullScreen(false);
    }

    const handleAddToCart = () => {
        const discountedPrice = item.comparePrice > 0
            ? item.price - (item.price * (item.comparePrice / 100))
            : item.price;

        addToCart({ ...item, id: IdDoc, quantity, price: discountedPrice, originalPrice: item.price });
        setConfirmationMessage(`${quantity} ${item.nombre} agregado al carrito`);
        setTimeout(() => {
            setConfirmationMessage(null);
        }, 3000);
    };

    if (ProgrLoading) {
        return <ProgressLoad />;
    }

    if (!item) {
        return <div>Producto no encontrado</div>;
    }

    return (
        <div className="item-containerDet">
            <img src={selectImg} alt={item.nombre} className="item-imageDet" onClick={openFullScreen} />
            <div className="details-wrapper">
                {item && <MenuThumbnails images={ConvertObjToArray(item.Img)} onClick={Select} />}

                <Typography variant="h6" color="primary" className="item-price">
                    ${item.comparePrice > 0 ? item.price - (item.price * (item.comparePrice / 100)) : item.price}
                </Typography>

                <Typography variant="h5" gutterBottom className="item-name">
                    {item.nombre}
                </Typography>

                <Typography variant="body1" color="textSecondary" className="item-compare-price">
                    ${item.price}
                </Typography>

                <div className="menu-container">
                    <WhatsAppButton phoneNumber={phoneNumber} url={url} className="menu-button" />
                    <LocationButton className="menu-button" Location={Location} />
                    <ShareButton title={item.nombre} description={item.nombre} url={url} className="menu-button" />
                </div>

                <Typography variant="h5" gutterBottom>
                    Detalles
                </Typography>

                <div className="product-details" dangerouslySetInnerHTML={{ __html: item.desc }}></div>

                <Form.Group controlId="quantity">
                    <Form.Label>Cantidad</Form.Label>
                    <Form.Control
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(parseInt(e.target.value))}
                        min="1"
                    />
                </Form.Group>

                <Button variant="primary" onClick={handleAddToCart}>
                    <FaShoppingCart /> Agregar al carrito
                </Button>

                {confirmationMessage && (
                    <div className="confirmation-message">
                        {confirmationMessage}
                    </div>
                )}
            </div>

            {isFullScreen && (
                <div className="fullscreen-modal" onClick={closeFullScreen}>
                    <Button variant="light" className="close-icon" onClick={closeFullScreen}>
                        &times;
                    </Button>
                    <img src={selectImg} alt={item.nombre} className="fullscreen-image" />
                </div>
            )}
        </div>
    );
};

export default DetalleProducto;
